import React from 'react';
import { PET_TYPES } from '../../../lib/constants';
import { OnboardingDraft } from './types';
import { Input } from '../../ui/Input';
interface StepLifestyleProps {
  data: Partial<OnboardingDraft>;
  updateData: (data: Partial<OnboardingDraft>) => void;
}
function SwitchRow({
  checked,
  onChange,
  label
}: {
  checked: boolean;
  onChange: (v: boolean) => void;
  label: string;
}) {
  return <div className="flex items-center justify-between py-4" data-id="element-1552">
      <span className="text-lg font-medium text-light-1" data-id="element-1553">{label}</span>
      <button type="button" role="switch" aria-checked={checked} onClick={() => onChange(!checked)} className={`relative inline-flex h-7 w-12 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors outline-none focus:outline-none focus-visible:outline-none ${checked ? 'bg-lime-1' : 'bg-dark-3'}`} data-id="element-1554">
        <span className={`pointer-events-none block h-6 w-6 rounded-full bg-dark-1 shadow-lg ring-0 transition-transform ${checked ? 'translate-x-5' : 'translate-x-0'}`} data-id="element-1555" />
      </button>
    </div>;
}
export function StepLifestyle({
  data,
  updateData
}: StepLifestyleProps) {
  const togglePetType = (val: string) => {
    const current = data.petTypes || [];
    if (current.includes(val as any)) {
      updateData({
        petTypes: current.filter(p => p !== val) as any
      });
    } else {
      updateData({
        petTypes: [...current, val] as any
      });
    }
  };
  return <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-1556">
      <div data-id="element-1557">
        <h2 className="text-2xl font-bold text-light-1" data-id="element-1558">Stil de viață</h2>
      </div>

      <div className="bg-dark-2 rounded-2xl border border-dark-3 px-6" data-id="element-1559">
        <div className="py-2" data-id="element-1560">
          <SwitchRow checked={data.isSmoker || false} onChange={v => updateData({
          isSmoker: v
        })} label="Sunt fumător" data-id="element-1561" />
          {data.isSmoker && <div className="pb-4 animate-in slide-in-from-top-2 fade-in duration-300" data-id="element-1562">
              <p className="text-sm text-light-3" data-id="element-1563">
                Voi fuma doar la exterior / pe balcon
              </p>
            </div>}
        </div>

        <div className="py-2" data-id="element-1564">
          <SwitchRow checked={data.hasPets || false} onChange={v => updateData({
          hasPets: v
        })} label="Am animale de companie" data-id="element-1565" />
          {data.hasPets && <div className="pb-6 space-y-4 animate-in slide-in-from-top-2 fade-in duration-300" data-id="element-1566">
              <div className="flex flex-wrap gap-2" data-id="element-1567">
                {PET_TYPES.map(pet => {
              const isSelected = (data.petTypes || []).includes(pet.value as any);
              return <button key={pet.value} onClick={() => togglePetType(pet.value)} className={`px-4 py-2 rounded-full text-sm font-medium transition-colors border ${isSelected ? 'bg-lime-4 border-lime-1 text-lime-1' : 'bg-dark-1 border-dark-3 text-light-3 hover:border-dark-4 hover:text-light-2'}`} data-id="element-1568">
                      {pet.label}
                    </button>;
            })}
              </div>

              {(data.petTypes || []).includes('other') && <Input placeholder="Spune-ne ce animal..." value={data.petOther || ''} onChange={e => updateData({
            petOther: e.target.value
          })} className="bg-dark-1 border-dark-3" data-id="element-1569" />}
            </div>}
        </div>
      </div>
    </div>;
}